export var PeriodEnum;
(function (PeriodEnum) {
    PeriodEnum["MONTHLY"] = "Monthly";
    PeriodEnum["QUARTERLY"] = "Quarterly";
    PeriodEnum["ANNUALLY"] = "Annually";
})(PeriodEnum || (PeriodEnum = {}));
